import { EReduxTypes } from 'ts/enums/redux.types';
import type { ILoadingState } from 'ts/interfaces/loading/loading';
import type { IReduxAction } from 'ts/interfaces/redux/redux.action';

const initialState: ILoadingState = {
  sign_up: false,
  sign_in: false,
  confirm_account: false,
  password_reset: false,
  password_forgot: false,
  google_auth: false,
  get_user: true,
  update_user: false,
  get_documents: true,
  save_edit_document: false,
  chatsHistory: false,
  threadHistory: false,
  currentThread: false,
  fileUpload: false,
  newMessageInThread: {}
};

const loadingReducer = (state = initialState, action: IReduxAction) => {
  switch (action.type) {
    case EReduxTypes.UPDATE_LOADING_COMPONENT: {
      const { components, loading } = action.data;

      components.forEach((item: keyof ILoadingState) => {
        state[item] = loading;
      });

      return {
        ...state
      };
    }

    case EReduxTypes.UPDATE_MULTIPLE_LOADING_COMPONENTS_WITH_ID: {
      const { components, loading, id } = action.data;

      components.forEach((item: any) => {
        if (item === 'newMessageInThread') {
          const key = item as keyof ILoadingState;
          const threadLoading = state[key] as Record<string, boolean>;
          state[key] = {
            ...threadLoading,
            [id]: loading
          } as any;
        }
      });

      return {
        ...state
      };
    }

    case EReduxTypes.SIGN_OUT: {
      return initialState;
    }

    default:
      return state;
  }
};

export default loadingReducer;
